var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    rx: 70,
    fill: "#F51616"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.2599 66.7251C85.2599 66.7251 84.1286 80.7563 83.4724 86.6668C83.1599 89.4897 81.4161 91.1438 78.5599 91.1959C73.1245 91.2938 67.6828 91.3001 62.2495 91.1855C59.5016 91.1293 57.787 89.4543 57.4807 86.6813C56.8203 80.7188 55.6953 66.7251 55.6953 66.7251",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1417 59.9992H52.8125",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3357 59.9992C79.7003 59.9992 78.2919 58.843 77.9711 57.2409L77.4648 54.7076C77.1523 53.5388 76.094 52.7305 74.8878 52.7305H66.069C64.8628 52.7305 63.8044 53.5388 63.4919 54.7076L62.9857 57.2409C62.6648 58.843 61.2565 59.9992 59.6211 59.9992",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.d529f625b2b5eed872011b726054b089.svg";
export { ForwardRef as ReactComponent };